import React, { useEffect, useState, memo, useRef } from 'react';
import '../../assets/styles/confirmation.scss';
import moment from 'moment';
import { SuccessIcon } from '../icons';
import { Colors } from '../../constants';
import useWindowDimensions from '../../custom_hooks/useWindowDimensions';
import { useTranslation } from 'react-i18next';
import { CalendarIcon , LocationIcon } from '../icons';

const Confirmation = memo((props) => {
    const [ showConfirmation, setShowConfirmation ] = useState(false);
    const [ acceptCancel, setAcceptCancel ] = useState(false);
    const [ name, setName ] = useState('');
    const [ color, setColor ] = useState('');
    const [ timezoneName, setTimezoneName ] = useState('');
    const [ times, setTimes ] = useState(null);
    const [ location, setLocation ] = useState(null);
    const [ buttonBgColor, setButtonBgColor ] = useState('');
    const [ buttonFontColor, setButtonFontColor ] = useState('');
    const { width } = useWindowDimensions();
    const [ isoTime, setIsoTime ] = useState(false);
    const [ timeInterval, setTimeInterval ] = useState(0);
    const { t } = useTranslation();
    const timesRef = useRef(null);

    useEffect(() => {
        if(props.showConfirmation){
            setShowConfirmation(true);
            setAcceptCancel(props.acceptCancel);
            setName(props.name || '');
            setColor(props.color);
            setButtonBgColor(props.color);
            setButtonFontColor(`#${Colors.white}`);
            setTimezoneName(props.timezoneName);
            setTimes(props.times);
            setLocation(props.location);
            setIsoTime(props.isoTime);
            setTimeInterval(props.timeInterval);
        }
        else{
            setShowConfirmation(false);
        }
    }, [props]);

    // when times updated
    useEffect(() => {
        // set to ref
        if(times){
            timesRef.current = times;
        }
    }, [times]);

    // function when user click back to schedule button
    const handleBackButton = () => {
        props.handleBackButton();
    };

    // callback function for button hover
    const mouseOver = () => {
        setButtonBgColor(`${color}10`);
        setButtonFontColor(color);
    };

    // callback function for button leave (mouse event)
    const mouseOut = () => {
        setButtonBgColor(color);
        setButtonFontColor(`#${Colors.white}`);
    };

    if(showConfirmation){
        if (props.redirectStatus && !acceptCancel) {
            window.top.location.href = props.redirectLink;
        }
        return(
            <div className="bg-modal">
                <div className="content">
                    <div className="confirmed">
                        <div className="text-confirm">
                            <SuccessIcon height={`${width <= 585 ? '16' : '20'}`} width={`${width <= 585 ? '16' : '20'}`} />
                            {!acceptCancel ?
                                <span>{t('Confirmed')}</span>
                            :
                                <span>{t('Canceled')}</span>}
                        </div>
                        {!acceptCancel && <p className="subtitle-text">{`${t('You are scheduled with')} ${name}`}</p>}

                        <div className="detail-wrap">
                            {!acceptCancel ?
                                <>
                                    <hr />
                                    <div className="detail-element">
                                        <div className="detail-icon">
                                            <CalendarIcon />
                                        </div>
                                        <div className="detail">
                                            <span>
                                                { isoTime === true ?
                                                    `${moment(timesRef.current,"x").tz(timezoneName).format("HH:mm")} - ${moment(timesRef.current,"x").tz(timezoneName).add(timeInterval, 'minutes').format('HH:mm')}` :
                                                    `${moment(timesRef.current,"x").tz(timezoneName).format("hh:mm a")}  - ${moment(timesRef.current,"x").tz(timezoneName).add(timeInterval, 'minutes').format('hh:mm a')}`
                                                }
                                            </span>
                                            <span>
                                                {`${t(moment(timesRef.current,"x").tz(timezoneName).format("dddd"))},
                                                    ${moment(timesRef.current,"x").tz(timezoneName).format("DD")}
                                                    ${t(moment(timesRef.current,"x").tz(timezoneName).format("MMMM"))}
                                                    ${moment(timesRef.current,"x").tz(timezoneName).format("YYYY")}
                                                    (${timezoneName})`}
                                            </span>
                                        </div>
                                    </div>
                                    {location &&
                                        <div className="detail-element">
                                            <div className="detail-icon location">
                                                <LocationIcon />
                                            </div>
                                            <div className="detail">
                                                { location === 'Ask Invitee' ? (
                                                    props.selectedLocation ? `${props.selectedLocation} (${t('Details will be sent via confirmation email')})` : ''
                                                ) :
                                                location}
                                            </div>
                                        </div>
                                    }
                                    <hr />
                                    <div className="detail bold text-left info">
                                        { t('A calendar invitation has been sent to your email address') }.
                                    </div>
                                </>
                            :
                                <div className="detail bold">
                                    { t('The meeting has been cancelled') }
                                </div>
                            }
                        </div>

                        { !acceptCancel && (
                            <button
                                onMouseOver={() => mouseOver()}
                                onMouseOut={() => mouseOut()}
                                style={{backgroundColor: buttonBgColor, color: buttonFontColor, borderColor: buttonBgColor }}
                                onClick={()=> handleBackButton() }
                                className="button-schedules">
                                    { t('Back to Schedule') }
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
    else return null;
});

export default Confirmation
